"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PriceService = exports.NetworkCoins = exports.StableCoins = void 0;
const ethers_1 = require("ethers");
const tokens_1 = require("../../tokens");
const conversion_1 = require("../conversion");
const axios_1 = __importDefault(require("axios"));
exports.StableCoins = ['USDT', 'USDC', 'DAI', 'MIMATIC', 'USDT.e', 'USDC.e', 'DAI.e', 'BUSD'];
exports.NetworkCoins = ['WMATIC', 'MATIC', 'BNB', 'WBNB', 'ETH', 'WETH', 'AVAX', 'WAVAX', 'OMNIA', 'WOMNIA', 'RBTC', 'WRBTC'];
class PriceService {
  async getPrice(token, netwrok = undefined) {
    let findToken = this.translateToken(token);
    const priceRequest = {
      chainId: findToken.chainId.toString(),
      address: findToken.address,
      symbol: findToken.symbol
    };
    const key = `${priceRequest.chainId}-${priceRequest.address.toLowerCase()}`;
    const currentSecond = +(new Date().getTime() / 1000).toFixed();
    const cached = PriceService.clientCache[key];
    if (cached && cached.expire > currentSecond) {
      return cached.price;
    }
    const params = new URLSearchParams(priceRequest);
    if (!PriceService.PRICE_URL) {
      throw new Error('PriceService.PRICE_URL must be set');
    }
    const response = await axios_1.default.get(`${PriceService.PRICE_URL}/api/v1/price?${params}`);
    const data = await response.data;
    PriceService.clientCache[key] = {
      price: data?.price,
      expire: currentSecond + PriceService.LOCAL_CACHE_EXPIRE_IN_SECOND
    };
    return data?.price;
  }
  translateToken(token) {
    let findToken = token;
    if (tokens_1.TokensHolder.isBaseToken(token.chainId, token.address)) {
      findToken = tokens_1.TokensHolder.getWrappedToken(token);
    }
    return findToken;
  }
  async CachePricesForANetwork(pchainId = '') {
    if (!PriceService.PRICE_URL) {
      throw new Error('PriceService.PRICE_URL must be set');
    }
    const currentSecond = +(new Date().getTime() / 1000).toFixed();
    const response = await axios_1.default.get(`${PriceService.PRICE_URL}/api/v1/price/all?chainId=${pchainId}`);
    const data = await response.data;
    for (const chainId in data) {
      for (const key in data[chainId]) {
        const cachekey = `${chainId}-${key.toLowerCase()}`;
        PriceService.clientCache[cachekey] = {
          price: data[chainId][key],
          expire: currentSecond + PriceService.LOCAL_CACHE_EXPIRE_IN_SECOND
        };
      }
    }
  }
  getTokenValueByAmount(token, amount) {
    try {
      if (!token.price || !amount) {
        return '0';
      }
      return conversion_1.Conversion.convertStringFromDecimal(conversion_1.Conversion.toSafeBigNumberByRemovingFraction(conversion_1.Conversion.convertStringFromDecimal(conversion_1.Conversion.convertStringToDecimal(token.price, token.decimals).mul(amount).toString(), token.decimals).toString()).toString(), token.decimals).toString();
    } catch (e) {
      console.log('Getting value from balance and price by error: ', e);
    }
  }
  getLPTokenPrice(chainId, poolAddress) {
    const token = new tokens_1.CrowdToken(chainId, poolAddress, 18, 'opp');
    return this.getPrice(token);
  }
  static usdtDecimal() {
    return 8;
  }
  getAmountIn(sourceInUSDT, swapSearchValue, srcDecimal, sourceValueIsInUSDT = false) {
    if (sourceValueIsInUSDT) {
      return conversion_1.Conversion.convertStringToDecimal(conversion_1.Conversion.convertStringFromDecimal(conversion_1.Conversion.toSafeBigNumberByAddingFraction(swapSearchValue).mul(ethers_1.ethers.constants.WeiPerEther).div(conversion_1.Conversion.toSafeBigNumberByAddingFraction(sourceInUSDT)).toString(), 18 - PriceService.usdtDecimal()), srcDecimal).toString();
    } else {
      return conversion_1.Conversion.convertStringToDecimal(swapSearchValue, srcDecimal).toString();
    }
  }
  getPriceFromPool(reserves, midPrice, tokenIn, tokenOut) {
    let tokenInPrice = tokenIn.price;
    let tokenOutPrice = tokenOut.price;
    if (reserves && reserves[0][0] !== '0' && midPrice) {
      const decimalDiff = tokenIn.decimals - tokenOut.decimals;
      if (exports.StableCoins.includes(tokenIn.symbol)) {
        const ratio = conversion_1.Conversion.convertStringFromDecimal(ethers_1.BigNumber.from(conversion_1.Conversion.convertStringToDecimal(midPrice.denominator.toString(), 18 - decimalDiff)).div(ethers_1.BigNumber.from(midPrice.numerator.toString())).toString(), 18);
        tokenOutPrice = (parseFloat(ratio.toString()) * parseFloat(tokenIn.price)).toString();
      } else if (exports.StableCoins.includes(tokenOut.symbol)) {
        const ratio = conversion_1.Conversion.convertStringFromDecimal(ethers_1.BigNumber.from(conversion_1.Conversion.convertStringToDecimal(midPrice.numerator.toString(), 18 + decimalDiff)).div(ethers_1.BigNumber.from(midPrice.denominator.toString())).toString(), 18);
        tokenInPrice = (parseFloat(ratio.toString()) * parseFloat(tokenOut.price)).toString();
      } else if (exports.NetworkCoins.includes(tokenIn.symbol)) {
        const ratio = conversion_1.Conversion.convertStringFromDecimal(ethers_1.BigNumber.from(conversion_1.Conversion.convertStringToDecimal(midPrice.denominator.toString(), 18 - decimalDiff)).div(ethers_1.BigNumber.from(midPrice.numerator.toString())).toString(), 18);
        tokenOutPrice = (parseFloat(ratio.toString()) * parseFloat(tokenIn.price)).toString();
      } else if (exports.NetworkCoins.includes(tokenOut.symbol)) {
        const ratio = conversion_1.Conversion.convertStringFromDecimal(ethers_1.BigNumber.from(conversion_1.Conversion.convertStringToDecimal(midPrice.numerator.toString(), 18 + decimalDiff)).div(ethers_1.BigNumber.from(midPrice.denominator.toString())).toString(), 18);
        tokenInPrice = (parseFloat(ratio.toString()) * parseFloat(tokenOut.price)).toString();
      }
    }
    return {
      tokenInPrice,
      tokenOutPrice
    };
  }
}
exports.PriceService = PriceService;
PriceService.LOCAL_CACHE_EXPIRE_IN_SECOND = 40;
PriceService.clientCache = {};
